import { useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function ProductCard({ product, testId }) {
  const { has, toggle } = useWishlist() || {};
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const wished = has ? has(product.id) : false;

  const onHeart = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!user) { toast.error("Sign in to save to your wishlist"); return; }
    setBusy(true);
    try { await toggle(product.id); toast.success(wished ? "Removed from wishlist" : "Saved to wishlist"); }
    catch { toast.error("Could not update wishlist"); }
    setBusy(false);
  };

  return (
    <Link to={`/product/${product.id}`} className="block group" data-testid={testId}>
      <div className="product-image-wrap relative">
        <img src={product.images?.[0]} alt={product.name} loading="lazy" />
        <button onClick={onHeart} disabled={busy}
                aria-label="Save to wishlist" data-testid={`wishlist-toggle-${product.id}`}
                className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-[#F7F5F0]/90 backdrop-blur hover:bg-[#F7F5F0]">
          <Heart className={`w-4 h-4 ${wished ? "fill-[#B24C38] text-[#B24C38]" : "text-[#111]"}`} strokeWidth={1.5}/>
        </button>
      </div>
      <div className="mt-4 flex justify-between items-start gap-3">
        <div>
          <p className="text-xs text-[#4A4A4A] label-uppercase">{product.category}</p>
          <p className="font-serif text-lg md:text-xl leading-tight mt-1">{product.name}</p>
        </div>
        <p className="font-serif text-lg md:text-xl whitespace-nowrap">${product.price.toFixed(0)}</p>
      </div>
    </Link>
  );
}
